import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./SubTitleSection.module.less";
import classNames from "classnames";

export type SubTitleSectionProps = {
	text: string | ReactElement;
	trackingId: string;
	isEmpty?: boolean;
};

export const SubTitleSection = (props: SubTitleSectionProps): ReactElement => {
	const {
		text,
		trackingId,
		isEmpty = false
	} = props;

	return (
		<span
			{...setTrackingId(trackingId)}
			className={
				classNames(
					styles.root,
					{[styles.root_empty]: isEmpty}
				)
			}
		>
			{text}
		</span>
	);
};
SubTitleSection.displayName = "SubTitleSection";